import type { CleaningPrestation, User } from '@wecasa/common/src/types/commons';

import type { BasketState } from '@wecasa/customer/src/ducks/types';
import type { Price } from '@wecasa/customer/src/types/prices';

import { hasMembership } from '@wecasa/membership/src/utils/membership';

import MemberWithRecurringPrestation from './member/member-with-recurring-prestation';
import MemberWithSpotPrestation from './member/member-with-spot-prestation';
import NotMemberWithRecurringPrestation from './not-member/not-member-with-recurring-prestation';
import NotMemberWithSpotPrestation from './not-member/not-member-with-spot-prestation';

type MembershipCardContentProps = {
  user?: User;
  getMoreInfoPress: () => void;
  duration: BasketState['duration'];
  cleaningPrestation?: CleaningPrestation;
  reduction: Price;
};

const MembershipCardContent = ({
  user,
  getMoreInfoPress,
  duration,
  cleaningPrestation,
  reduction,
}: MembershipCardContentProps) => {
  const hasAlreadyMembership = hasMembership(user);
  const isSpot = !cleaningPrestation?.is_recurrent;

  if (hasAlreadyMembership) {
    return isSpot ? (
      <MemberWithSpotPrestation cleaningPrestation={cleaningPrestation} reduction={reduction} duration={duration} />
    ) : (
      <MemberWithRecurringPrestation cleaningPrestation={cleaningPrestation} getMoreInfoPress={getMoreInfoPress} />
    );
  }

  return isSpot ? (
    <NotMemberWithSpotPrestation reduction={reduction} getMoreInfoPress={getMoreInfoPress} duration={duration} />
  ) : (
    <NotMemberWithRecurringPrestation cleaningPrestation={cleaningPrestation} getMoreInfoPress={getMoreInfoPress} />
  );
};

export default MembershipCardContent;
